import React, {useState, useEffect} from 'react'

import classes from './PopupCredits.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import Texts from 'react-sdk/Texts';
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import { POPUPS } from '@/js/AppState';

const PopupCredits = () => {

  return (
    <Popup className={classes.PopupCredits}>
      <div className={classes.content}>
        <h2>{Texts.get("credits-title")}</h2>
        <div className={classes.text} dangerouslySetInnerHTML={{__html: Texts.get("credits-text")}} />

        <div className={classes.btn_ctnr}>
          <Button onClick={() => PopupsManager.close(POPUPS.CREDITS)} >Valider</Button>
        </div>
      </div>
   </Popup>
  );
};

export default PopupCredits;
